export default __webpack_public_path__ + "static/media/lavalmini.42129714.jpg";